import { FC } from 'react';
import { usePageContext } from '@providers/PageMetaProvider/model/PageContext';
import Button from '@mui/material/Button';
import { IoArrowBack } from 'react-icons/io5';
import Tooltip from '../Tooltip/ui/Tooltip';
import styles from './PageHeader.module.scss';

/**
 * @description - A React component that displays an header of signed-in pages.
 */

const PageHeader: FC = () => {
  const { values } = usePageContext();

  return (
    <div
      className={[
        styles.pageHeader,
        values?.withBorder && styles.bordered,
      ].join(' ')}
    >
      <div className={styles.text}>
        {values?.backButton && (
          <Button
            onClick={values.backButtonAction}
            variant="text"
            sx={{
              marginBottom: '16px',
              displayPrint: 'none',
            }}
            startIcon={<IoArrowBack />}
          >
            {values?.backNavigationLabel || 'Back'}
          </Button>
        )}
        {values?.title && <h2 className={styles.title}>{values.title}</h2>}
        {values?.description && (
          <div className={styles.description}>
            <p>{values?.description}</p>
            {values?.tooltipQuestionTitle && (
              <Tooltip questionTitle={values.tooltipQuestionTitle}>
                {values?.tooltipText}
              </Tooltip>
            )}
          </div>
        )}
        {values?.versionSelector && values.versionSelector()}
        {values?.descriptionElement && (
          <div className={styles.descriptionElement}>
            {values.descriptionElement()}
          </div>
        )}
      </div>
      <div className={styles.additional}>
        {values?.additional ? values.additional() : null}
      </div>
    </div>
  );
};

export default PageHeader;
